import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, tap, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  return next(req).pipe(
    tap((res: any) => {
      if (res?.body?.errors) {
        // Only redirect to login if it's a real auth failure AND user has no token
        // (meaning session truly expired, not just a permission error)
        if (checkForUnauthorizedError(res.body.errors) && !hasValidToken()) {
          window.location.href = '/login';
        }
      }
    }),
    catchError((err: any) => {
      if (err instanceof HttpErrorResponse) {
        // HTTP 401 = real authentication failure (token expired/invalid)
        if (err.status === 401) {
          window.location.href = '/login';
          return throwError(() => err);
        }
      }

      let e = err as any;
      if (e.error?.errors) {
        if (checkForUnauthorizedError(e.error.errors) && !hasValidToken()) {
          window.location.href = '/login';
        }
      }

      const gqlError = err?.error?.errors?.[0];
      // Prefer extensions.message (detailed) over generic message
      if (gqlError?.extensions?.message) {
        gqlError.message = gqlError.extensions.message;
      }
      return throwError(() => gqlError);
    }),
  );
};

function checkForUnauthorizedError(errs: any[]) {
  for (let err of errs)
    if (err?.extensions?.code === 'AUTH_NOT_AUTHORIZED') return true;
  return false;
}

function hasValidToken(): boolean {
  try {
    const storedUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    const token = storedUser?.authToken || storedUser?.token;
    if (!token) return false;

    // Check if JWT is expired
    const payload = JSON.parse(atob(token.split('.')[1]));
    const exp = payload.exp * 1000; // Convert to ms
    return Date.now() < exp;
  } catch {
    return false;
  }
}
